import { useState, useEffect, useRef } from 'react';
import { EventEmitter } from '@/controllers/EventEmitter';
import { useInterval } from '@/ui/hooks/useInterval';
import { EventPayloads } from '@/helpers/types';
import { cssVars } from '@/ui/lib/utils';
import './sentEmojis.css';

const MAX_CONCURRENT = 10;
const DRAIN_INTERVAL_MS = 150;

interface SentEmoji {
    id: number;
    emoji: string;
    position: string;
}

export const SentEmojis = () => {
    const [sentEmojis, setSentEmojis] = useState<SentEmoji[]>([]);
    const queue = useRef<string[]>([]);

    const handleAnimationEnd = (id: number) => {
        setSentEmojis((prev) => prev.filter((fe) => fe.id !== id));
    };

    useEffect(() => {
        const handler = (payload: EventPayloads['common:emoji']) => {
            queue.current.push(payload.emojiMap);
        };

        EventEmitter.on('common:emoji', handler);
        return () => EventEmitter.off('common:emoji', handler);
    }, []);

    useInterval(() => {
        if (queue.current.length === 0) return;

        setSentEmojis((prev) => {
            if (prev.length >= MAX_CONCURRENT) return prev;
            const next = queue.current.shift();
            if (!next) return prev;

            return [
                ...prev,
                {
                    id: Date.now(),
                    emoji: next,
                    position: `${Math.floor(Math.random() * 101)}px`,
                },
            ];
        });
    }, DRAIN_INTERVAL_MS);

    return (
        <div className="sent-emojis">
            {sentEmojis.map((fe) => (
                <img
                    key={fe.id}
                    className="sent-emoji"
                    src={`assets/images/Emojis/${mapEmoji(fe.emoji)}.png`}
                    alt={`Flying emoji ${fe.emoji}`}
                    style={cssVars({ '--emoji-left': fe.position })}
                    onAnimationEnd={() => handleAnimationEnd(fe.id)}
                />
            ))}
        </div>
    );
};

//TODO: check - Temporary solution to remmap emojis
export function mapEmoji(emoji: string) {
    switch (emoji) {
        case '🎉':
            return 'celebration';
        case '❤️':
            return 'flag';
        case '💩':
            return 'shite';
        default:
            return emoji;
    }
}
